import { IRegionWellWaterSystemResult } from "../../types";

export const defaultRegionHousingUnits: IRegionWellWaterSystemResult[] =  [
    {
        "totalHousingUnits": 29963980,
        "epaRegion": "04",
        "region": "Region 04"
    },
    {
        "totalHousingUnits": 23375577,
        "epaRegion": "05",
        "region": "Region 05"
    },
    {
        "totalHousingUnits": 19316129,
        "epaRegion": "09",
        "region": "Region 09"
    },
    {
        "totalHousingUnits": 17715354,
        "epaRegion": "06",
        "region": "Region 06"
    },
    {
        "totalHousingUnits": 13546522,
        "epaRegion": "03",
        "region": "Region 03"
    },
    {
        "totalHousingUnits": 12249253,
        "epaRegion": "02",
        "region": "Region 02"
    },
    {
        "totalHousingUnits": 6724375,
        "epaRegion": "01",
        "region": "Region 01"
    },
    {
        "totalHousingUnits": 6319377,
        "epaRegion": "07",
        "region": "Region 07"
    },
    {
        "totalHousingUnits": 6093642,
        "epaRegion": "10",
        "region": "Region 10"
    },
    {
        "totalHousingUnits": 5193525,
        "epaRegion": "08",
        "region": "Region 08"
    }
]